import React, { useState, useRef } from "react";
import { Layout } from "antd";
const { Header } = Layout;
import style from "./index.less";
export default function Index() {
  return (
    <>
      <div className={style.head} />
      <Header className={style.header}>
        <div className={style.title}>账号管理平台</div>
      </Header>
    </>
  );
}
